<template>
    <a
        :href="logoLinkDestination"
        :target="target">
        <div v-if="logoLink === '/residential' || logoLink === '/communities' || logoLink === '/my world'">
            <img fetchpriority="high" src="../../../../public/static/bzl-logos/breezeline2.webp" alt="Breezeline Logo">
        </div>
        <div v-else>
            <img fetchpriority="high" src="../../../../public/static/bzl-logos/businessLogo.webp" alt="Business Logo">
        </div>
        <title id="logotitle">Breezeline logo</title>
    </a>

</template>

<script>
export default {
    name: 'AppLogo',
    props: {
        logoLink: {
            type: String,
            default: () => [],
        },
        target: {
            type: String,
            default: "_blank",
        },
    },
    computed: {
        logoLinkDestination () {
            // Clicking on the Breezeline Logo on Support Center will be redirected to Breezeline homepage
            const hostname = window.location.hostname;
            if (hostname === "support.breezeline.com") {
                return "https://www.breezeline.com";
            }

            if (this.logoLink === '/residential' || this.target === '_parent') {
                return '/'
            }
            return this.logoLink
        },
    },
}
</script>
